import React from "react";
import Modal from "./Modal";

type RecordbookMissing = Record<string, unknown> | null | undefined;

function extractMissingTables(recordbookMissing: RecordbookMissing): string[] {
  if (!recordbookMissing || typeof recordbookMissing !== "object") return [];
  const raw = (recordbookMissing as any).missing_tables ?? (recordbookMissing as any).tables ?? (recordbookMissing as any).missing;
  if (Array.isArray(raw)) return raw.map(String);
  if (raw && typeof raw === "object") return Object.keys(raw);
  return [];
}

interface RecordbookUploadNoticeModalProps {
  isOpen: boolean;
  teamName?: string;
  recordbookMissing?: RecordbookMissing;
  onAcknowledge: () => void;
}

const RecordbookUploadNoticeModal: React.FC<RecordbookUploadNoticeModalProps> = ({
  isOpen,
  teamName,
  recordbookMissing,
  onAcknowledge,
}) => {
  const missingTables = extractMissingTables(recordbookMissing);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onAcknowledge}
      showCloseButton={false}
      closeOnBackdrop={false}
      closeOnEsc={false}
      panelClassName="bg-white p-6 rounded-lg shadow-lg w-[520px] relative"
    >
      <div className="flex flex-col gap-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Record data upload</h2>
          <p className="mt-2 text-sm text-gray-700">
           Your record book data will be processed and available within a few days. You will have immediate access to the available genius data for all sports you choose. For the trial period, only football, men’s basketball and women’s basketball will be visible.
          </p>
        </div>

        {missingTables.length > 0 && (
          <div className="bg-gray-50 border border-gray-200 rounded-md p-3">
            <div className="text-xs font-semibold text-gray-600 uppercase">Missing tables</div>
            <div className="mt-2 flex flex-wrap gap-2">
              {missingTables.slice(0, 24).map((t) => (
                <span key={t} className="text-xs px-2 py-1 rounded bg-white border border-gray-200 text-gray-700">
                  {t}
                </span>
              ))}
              {missingTables.length > 24 && (
                <span className="text-xs text-gray-500">+{missingTables.length - 24} more</span>
              )}
            </div>
          </div>
        )}

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onAcknowledge}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded"
          >
            Ok
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RecordbookUploadNoticeModal;

